export default __webpack_public_path__ + "static/media/norbuHome.dee6b3be.png";